var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4805 8.78067L23.422 0.789759C24.4685 -0.263253 26.1672 -0.263253 27.2137 0.789759C28.2602 1.84277 28.2602 3.55201 27.2137 4.60502L19.2722 12.5959C18.3237 13.5503 17.038 14.0868 15.6963 14.0868H13.9988V12.3788C13.9988 11.0287 14.532 9.73507 15.4805 8.78067ZM24.2037 10.9548L20.9218 14.257C19.5358 15.6517 17.6575 16.4347 15.6975 16.4347H12.8333C12.1893 16.4347 11.6667 15.9087 11.6667 15.2607V12.3788C11.6667 11.7577 11.7507 11.152 11.8965 10.565H5.83333C2.61217 10.565 0 13.1935 0 16.4347V21.1304C0 24.3716 2.61217 27 5.83333 27H22.1667C25.3878 27 28 24.3716 28 21.1304V16.4347C28 13.9225 26.4145 11.7906 24.2037 10.9548ZM6.41667 21.0799C5.45067 21.0799 4.66667 20.291 4.66667 19.319C4.66667 18.347 5.45067 17.5581 6.41667 17.5581C7.38267 17.5581 8.16667 18.347 8.16667 19.319C8.16667 20.291 7.38267 21.0799 6.41667 21.0799ZM12.25 21.0799C11.284 21.0799 10.5 20.291 10.5 19.319C10.5 18.347 11.284 17.5581 12.25 17.5581C13.216 17.5581 14 18.347 14 19.319C14 20.291 13.216 21.0799 12.25 21.0799Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.71a9ff54891cad1a9506fe2e1068d542.svg";
export { ForwardRef as ReactComponent };